import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import Button from "@mui/material/Button"
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined"
import { apiEndPoints } from "constants/apiEndpoints"
import { toast } from "react-toastify"
import Cookies from "js-cookie"
import "./GateLinkActivate.css"
import axios from "axios"
import { useTranslation } from "react-i18next"

const GateLinkActivate = () => {
  const { t } = useTranslation()
  const [posterUrl, setPosterUrl] = useState("")
  const dispatch = useDispatch()

  const clickHandler = () => {
    window.open(posterUrl, "_blank")
    return false
  }

  useEffect(() => {
    let urlParams: any = new URLSearchParams(window.location.search)
    let encodedData: string = urlParams.get("data")

    let base64ToString = Buffer.from(encodedData, "base64").toString()
    let decodedData = JSON.parse(base64ToString)

    let authToken = Cookies.get("onboarding-auth-token")
    let deviceId = Cookies.get("onboarding-device-id")
    let userId = Cookies.get("onboarding-user-id")

    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + authToken,
      "X-FourKitesDeviceId": deviceId,
      "X-FourKitesUserId": userId
    }

    axios
      .post(
        `${apiEndPoints.facilities}`,
        {
          code: decodedData?.code,
          name: decodedData?.name,
          shipperPermalink: decodedData?.shipperPermalink,
          address: {
            city: decodedData?.city,
            street: decodedData?.street,
            state: decodedData?.state
          }
        },
        {
          headers: headers
        }
      )
      .then(response => {
        const { data } = response.data
        setPosterUrl(data?.posterUrl)
        dispatch({
          type: "SET_PATH",
          payload: "activate-network-tracking"
        })
      })
      .catch(err => toast.error(err.response.data.error))
  }, [])

  return (
    <div className="active-gl-wrapper container">
      <div className="active-gl-header-text">
        {t("thank_you_for_activating_fast_track")}
      </div>
      <p>{t("activating_msg")}</p>
      <p> {t("get_started_text")}</p>
      <Button
        sx={{
          bgcolor: "#E7F0FC",
          borderRadius: 1,
          color: "#0E65E5",
          fontWeight: 600,
          padding: 0,
          width: "200px",
          height: "32px",
          fontFamily: "Lato",
          fontStyle: "normal",
          fontSize: "14px",
          textTransform: "none"
        }}
        variant="outlined"
        onClick={clickHandler}
        startIcon={<ArrowDownwardOutlinedIcon />}
      >
        Preview and Download
      </Button>
      {/* <div className="active-gl-header-text">
        Have Questions? Check out our useful links:
      </div>
      <a
        className="anchor-tag"
        href="https://www.w3schools.com"
        target="_blank"
      >
        How does this work?
        <LaunchIcon fontSize="small" />
      </a>
      <a
        className="anchor-tag"
        href="https://www.w3schools.com"
        target="_blank"
      >
        Gate Guard Manual
        <LaunchIcon fontSize="small" />
      </a>
      <a
        className="anchor-tag"
        href="https://www.w3schools.com"
        target="_blank"
      >
        Shipper Users Manual
        <LaunchIcon fontSize="small" />
      </a>
      <a
        className="anchor-tag"
        href="https://www.w3schools.com"
        target="_blank"
      >
        Drivers Manual
        <LaunchIcon fontSize="small" />
      </a> */}
    </div>
  )
}

export default GateLinkActivate
